<template>
  <div class="modal modal-termos fade" id="modalTermo" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
            <div class="modal-body">
                <div class="modal-termos--box">
                  <h5 class="modal-termos--title">Termos e condições</h5>
                  <p class="modal-termos--subtitle">
                    Política de Trocas e Devoluções
                  </p>
                  <p>
                    Toda equipe Heliar Express trabalha para que você tenha sempre a melhor experiência na troca da sua bateria, seja em nossas lojas físicas ou canais on-line. Confira algumas informações importantes para realizar o pedido da sua bateria.
                  </p>
                  <br>
                  <p class="modal-termos--subtitle">
                    A – Sobre o Heliar Express
                  </p>
                  <p>
                    Heliar Express é um serviço de entrega e instalação de baterias automotivas. Através dele é possível pedir, receber e instalar uma bateria Heliar de forma prática e rápida de onde estiver. Basta acessar www.heliarexpress.com.br e fazer seu pedido. Também é possível realizar o pedido por telefone ao custo de uma ligação local 4090-2020.
                  </p>
                  <br>
                  <p class="modal-termos--subtitle">
                    B. Condições gerais de compra
                  </p>
                  <p>
                    O primeiro passo para pedir sua bateria é identificar qual é o modelo recomendado para o seu veículo, através da marca, ano e modelo do carro. <br>
                    Após a compra e instalação, a troca ou devolução da bateria será realizada de acordo com as condições disponíveis no certificado de garantia que acompanha o produto.
                  </p>
                  <br>
                  <p class="modal-termos--subtitle">
                    C. Cancelamento de pedido
                  </p>
                  <p>
                    O cancelamento do pedido poderá ser realizado a qualquer momento, desde que seja antes da instalação da bateria.  Recomendamos que seja até 30 minutos antes da programação da entrega. <br>
                    Para cancelar seu pedido é necessário ligar na central de atendimento: 4090-2020.
                  </p>
                  <br>
                </div>
            <button type="button" class="modal-termos--btn" data-dismiss="modal" aria-label="Close">
              Entendi
            </button>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    name: "Termo"
}
</script>

<style lang="scss">
  .modal-termos {
    max-height: 85vh;
    &--title {
        font-size: 22px;
        color: $cinza-escuro;
        font-weight: bold;
        text-transform: uppercase;
    }
    &--subtitle {
        font-size: 13px;
        font-weight: bold;
        margin-bottom: 5px;
    }
    p {
        color: $cinza-escuro;
    }
    &--btn {
        background-color: $verde-escuro;
        padding: 10px 20px;
        color: $white;
        font-size: 20px;
        margin-left: auto;
        margin-top: 15px;
        float: right;
    }
    &--box {
        overflow: auto;
        height: 45vh;
        padding: 15px;
        box-shadow: 0 0 20px -1px rgba(0, 0, 0, 0.35);
    }
}
</style>